import { type RefObject } from "react";
import { type FormValues } from "../types";

export type HiddenFormProps = {
  formRef: RefObject<HTMLFormElement>;
  action: string;
  values: FormValues;
  distanceMeter: string;
};

export const HiddenForm = (props: HiddenFormProps) => {
  const { formRef, action, distanceMeter, values } = props;
  const {
    "q[salon_tour_flag]": salonTourFlag,
    "q[client_end_up_close_flag]": clientEndUpCloseFlag,
    ...rest
  } = values;

  return (
    <form ref={formRef} action={action} acceptCharset="UTF-8" method="post">
      {Object.entries({ ...rest, "q[distance_meter]": distanceMeter }).flatMap(([name, value]) => {
        if (Array.isArray(value)) {
          return value.map((v) => (
            <input key={`${name}-${String(v)}`} type="hidden" name={name} value={String(v)} />
          ));
        }
        return <input key={name} type="hidden" name={name} value={String(value)} />;
      })}
      {/* NOTE: falseの場合はhiddenフィールドを送信しない（falseをvalueとして送信するとサーバー側でtrueと判定される可能性があるため) */}
      {salonTourFlag && <input type="hidden" name="q[salon_tour_flag]" value="true" />}
      {clientEndUpCloseFlag && (
        <input type="hidden" name="q[client_end_up_close_flag]" value="true" />
      )}
    </form>
  );
};
